export enum TextStyle_TextAlignment {
  /** AUTO - browser default, eqivalent to `initial` */
  AUTO = "AUTO",
  /** LEFT - Left align */
  LEFT = "LEFT",
  /** RIGHT - Right align */
  RIGHT = "RIGHT",
  /** CENTER - Center align */
  CENTER = "CENTER",
  /** JUSTIFY - Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
  JUSTIFY = "JUSTIFY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Link_Target {
  /** SELF - Opens the linked document in the same frame as it was clicked (this is default) */
  SELF = "SELF",
  /** BLANK - Opens the linked document in a new window or tab */
  BLANK = "BLANK",
  /** PARENT - Opens the linked document in the parent frame */
  PARENT = "PARENT",
  /** TOP - Opens the linked document in the full body of the window */
  TOP = "TOP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum PluginContainerData_Alignment {
  /** CENTER - Center Alignment */
  CENTER = "CENTER",
  /** LEFT - Left Alignment */
  LEFT = "LEFT",
  /** RIGHT - Right Alignment */
  RIGHT = "RIGHT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum PluginContainerData_Width_Type {
  /** CONTENT - Width matches the content width */
  CONTENT = "CONTENT",
  /** SMALL - Small Width */
  SMALL = "SMALL",
  /** ORIGINAL - Width will match the original asset width */
  ORIGINAL = "ORIGINAL",
  /** FULL_WIDTH - coast-to-coast display */
  FULL_WIDTH = "FULL_WIDTH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Gradient type. */
export enum Gradient_Type {
  /** LINEAR - Linear gradient. */
  LINEAR = "LINEAR",
  /** RADIAL - Radial gradient. */
  RADIAL = "RADIAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}